import { gql } from "@apollo/client";

export const USER_FIELDS_FRAGMENT = gql`
  fragment UserFields on UserType {
    id
    bio
    experiencesCount
    experiencesCountFacets {
      category {
        id
        name
        slug
      }
      count
    }
    facebookUrl
    firstName
    followers(limit: 3) {
      id
      imageId
      username
    }
    followersCount
    imageId
    instagramUrl
    isBlocked @include(if: $isUser)
    isFollowing @include(if: $isUser)
    isFollower @include(if: $isUser)
    lastName
    location
    pronouns
    reviewsCount
    tiktokUrl
    twitterUrl
    username
    websiteUrl
    wishlistedCount
  }
`;

export const QUERY = gql`
  ${USER_FIELDS_FRAGMENT}

  query User($isUser: Boolean!, $username: String!) {
    user(username: $username) {
      ...UserFields
    }
  }
`;

export const SSR_QUERY = gql`
  ${USER_FIELDS_FRAGMENT}

  query User($isUser: Boolean!, $username: String!) {
    user(username: $username) {
      ...UserFields
    }
    badges(pageSize: 12, username: $username) {
      count
      objects {
        id
        description
        earnedAt
        image
        name
      }
    }
  }
`;

export const SSR_BADGES_QUERY = gql`
  ${USER_FIELDS_FRAGMENT}

  query User($categorySlugs: [String], $isUser: Boolean!, $username: String!) {
    user(username: $username) {
      ...UserFields
    }
    badges(categorySlugs: $categorySlugs, pageSize: 1000, username: $username) {
      facets {
        type
        items {
          id
          name
          slug
          count
        }
      }
      objects {
        id
        description
        earnedAt
        image
        name
      }
    }
  }
`;
